import { MODULES } from 'config/constants/modules';
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';

import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Grid } from '@material-ui/core';
import NFTItemDisplay from 'components/NFTItemDisplay';
import { useSelector } from 'react-redux';
import { State } from 'models/state.model';
import { useNFTCollection } from 'state/nft/hooks';
import NFTItemDisplayLoader from 'components/NFTItemDisplayLoader';

const NFTCollection: React.FC = () => {
	useNFTCollection();

	const recentListedItems = useSelector((state: State) => state.nft.recentListedItems);

	const mostFavoritedItems = useSelector((state: State) => state.nft.mostFavoritedItems);

	const isRecentListedItemsLoading = useSelector(
		(state: State) => state.nft.isRecentListedItemsLoading
	);

	const isMostFavoritedItemsLoading = useSelector(
		(state: State) => state.nft.isMostFavoritedItemsLoading
	);

	return (
		<StyledWraper>
			<StyledTitleSection>
				<div className="title">
					<Trans>Recently Listed</Trans>
				</div>
				<Link className="link" to={MODULES.MARKETPLACE}>
					<Trans>See More</Trans> <ChevronRightIcon />
				</Link>
			</StyledTitleSection>

			<StyledNFTList container spacing={3}>
				{!isRecentListedItemsLoading &&
					recentListedItems.map((item) => (
						<StyledGridItem key={item.id} item xs={6} sm={6} md={3}>
							<NFTItemDisplay item={item} />
						</StyledGridItem>
					))}

				{isRecentListedItemsLoading && (
					<>
						<StyledGridItem item xs={6} sm={6} md={3}>
							<NFTItemDisplayLoader />
						</StyledGridItem>
						<StyledGridItem item xs={6} sm={6} md={3}>
							<NFTItemDisplayLoader />
						</StyledGridItem>
						<StyledGridItem item xs={6} sm={6} md={3}>
							<NFTItemDisplayLoader />
						</StyledGridItem>
						<StyledGridItem item xs={6} sm={6} md={3}>
							<NFTItemDisplayLoader />
						</StyledGridItem>
					</>
				)}
			</StyledNFTList>

			<StyledTitleSection>
				<div className="title">
					<Trans>Most Popular</Trans>
				</div>
				<Link className="link" to={MODULES.MARKETPLACE}>
					<Trans>See More</Trans> <ChevronRightIcon />
				</Link>
			</StyledTitleSection>

			<StyledNFTList container spacing={3}>
				{!isMostFavoritedItemsLoading &&
					mostFavoritedItems.map((item) => (
						<StyledGridItem key={item.id} item xs={6} sm={6} md={3}>
							<NFTItemDisplay item={item} />
						</StyledGridItem>
					))}

				{isMostFavoritedItemsLoading && (
					<>
						<StyledGridItem item xs={6} sm={6} md={3}>
							<NFTItemDisplayLoader />
						</StyledGridItem>
						<StyledGridItem item xs={6} sm={6} md={3}>
							<NFTItemDisplayLoader />
						</StyledGridItem>
						<StyledGridItem item xs={6} sm={6} md={3}>
							<NFTItemDisplayLoader />
						</StyledGridItem>
						<StyledGridItem item xs={6} sm={6} md={3}>
							<NFTItemDisplayLoader />
						</StyledGridItem>
					</>
				)}
			</StyledNFTList>
		</StyledWraper>
	);
};

const StyledWraper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
`;

const StyledGridItem = styled(Grid)`
	@media (max-width: 450px) {
		&.MuiGrid-grid-xs-6 {
			flex-grow: 0;
			max-width: 100%;
			flex-basis: 100%;
		}
	}
`;

const StyledTitleSection = styled.div`
	display: flex;
	margin: 48px 0px;
	width: 100%;
	justify-content: space-between;

	.title {
		font-style: normal;
		font-weight: bold;
		font-size: 20px;
		line-height: 23px;
		color: #fff;
	}

	.link {
		text-decoration: none;

		color: ${(props) => props.theme.color.yellow[100]};
		font-style: normal;
		font-weight: bold;
		font-size: 16px;
		line-height: 18px;
		display: flex;
		align-items: center;

		:hover {
			text-decoration: underline;
		}
	}
`;

const StyledNFTList = styled(Grid)`
	@media (max-width: 580px) {
		padding: 10px;
	}
`;

export default NFTCollection;
